module.exports = __webpack_public_path__ + "static/media/next-icon-straw-o.63212be7.svg";